import React from 'react';
import FeaturedAuthorTutoring from '../FeaturedAuthorTutoring';

import imageSrc from './sujata.jpg';

const OrionTutoring = () => {
  return (
    <FeaturedAuthorTutoring
      imageSrc={imageSrc}
      description="Ready to achieve higher USMLE scores? With 1,000+ hours of tutoring experience, a 250+ USMLE score, and a 95%+ student pass rate, Dr. Sujata can help you achieve your USMLE goals. She is the author of Achievable USMLE Step 1 and has helped students succeed at their USMLE Step 1, 2, and 3 exams from US and international medical schools. No matter where you are in your preparation journey, Dr. Sujata can assist with your success. She will work with you to improve on weak subject areas, apply the concepts to USMLE style questions, and train you to study smarter. Special discounts are available for Achievable students. Schedule a free consulting session today!"
      url="https://www.graceusmletutoring.com/?utm_source=achievable"
      cta="Visit Sujata's site"
    />
  );
};

export default OrionTutoring;
